import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import cardsOverview from "./cards-overview.json";
import settings from "./settings.json";
import transactions from "./transactions.json";

const wscManagement = {
  ...getI18nJsonProp(base, "wscManagement"),
  ...getI18nJsonProp(cardsOverview, "wscManagement"),
  ...getI18nJsonProp(settings, "wscManagement"),
  ...getI18nJsonProp(transactions, "wscManagement"),
};

export default wscManagement;
